import { useEffect } from 'react';
import { useMapContext } from 'entities/map';

import { MapProps } from '../';

export const useUpdateMapWidgets = (widgets: MapProps['widgets']) => {
  const { map } = useMapContext();

  useEffect(() => {
    map?.updateWidgets(widgets);
  }, [widgets, map]);
};
